module.exports = __webpack_public_path__ + "static/media/G26.eae6b874.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gp/G26.jpg
// module id = 79
// module chunks = 0